import React from 'react';

const Form = props => {
  const { children, contentRef = null, ...restProps } = props;

  const formProps = {
    // These are mainly default values for the server
    // rendering. Otherwise the form would submit potentially
    // sensitive data with the default GET method until the client
    // side code is loaded.
    method: 'post',
    action: '/',

    // allow content ref function to be passed to the form
    ref: contentRef,

    ...restProps,
  };
  return <form {...formProps}>{children}</form>;
};

export default Form;
